import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';

type Props = {
    icon?: React.ReactNode;
    text?: string;
    onClick?: () => void;
    children?: React.ReactNode;
};

export const ButtonBack: React.FC<Props> = ({
    icon = <ArrowLeftOutlined />,
    text = 'Back',
    onClick,
    children,
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };

    return (
        <StyledBackButton onClick={handleClick} aria-label='Go back'>
            <span>{icon}</span>
            {children ? children : <StyledText>{text}</StyledText>}
        </StyledBackButton>
    );
};

const StyledBackButton = styled.button`
    display: flex;
    align-items: center;
    gap: 18px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
`;

const StyledText = styled.span`
    font-size: 20px;
    font-weight: bold;
`;
